export const catalog_matrix = [
  {form_key:'bank_id', catalog_key:'banks'},
  {form_key:'currency_id', catalog_key:'currencies'},
]